<template>
  <el-dialog
    @open="onOpen"
    :visible.sync="visibility"
    :before-close="abortarSelecao"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    width="60%">
    <span slot="title">
      <font-awesome-icon icon="building" />
      Selecionar Imóvel
    </span>

    <el-form size="mini">
      <el-col :span="12"> 
      </el-col>
      <el-form-item
          label="Filtrar por:"
          style="width: 100%; font-weight: bold">
          <el-radio-group style="font-size: small" v-model="tipoOperacao">
            <el-radio label="TODOS" style="margin-top: 20px">Todos</el-radio>
            <el-radio label="VENDA" style="margin-top: 5px">Imóvel para venda</el-radio>
            <el-radio label="ALUGUEL" style="margin-top: 5px">Imóvel para aluguel</el-radio>
          </el-radio-group>
        </el-form-item>
        
      <el-row :gutter="10">
        <el-col :md="4" :lg="4">
          <el-form-item label="ID">
            <el-autocomplete
              v-model="imovelPesquisa.idNaImobiliaria"
              :fetch-suggestions="idInputHandler"
              :debounce="1000"
              clearable
              @clear="limparIdImovelPesquisaHandler"
              :trigger-on-focus="false"
              :hide-loading="true"
              popper-class="invisible-autocomplete-popper"
              style="width: 100%">
            </el-autocomplete>
          </el-form-item>
        </el-col>
        <el-col :md="20" :lg="20">
          <el-form-item label="Endereço">
            <el-autocomplete
              v-model="imovelPesquisa.endereco"
              :fetch-suggestions="enderecoInputHandler"
              :debounce="1000"
              clearable
              @clear="limparEnderecoImovelPesquisaHandler"
              :trigger-on-focus="false"
              :hide-loading="true"
              popper-class="invisible-autocomplete-popper"
              style="width: 100%">
            </el-autocomplete>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row type="flex" justify="end">
      <h4 style="color: #606266; margin: 0px 15px 5px 0px">
        {{ this.atualizarLabelQuantidade }}
      </h4>
    </el-row>

    <el-table
      :data="listaFiltrada"
      @current-change="selecaoLinhaHandler"
      @row-dblclick="cliqueDuploLinhaHandler"
      empty-text="Nenhum Imóvel encontrado"
      highlight-current-row
      height="250"
      stripe
      border
    >
      <el-table-column prop="idNaImobiliaria" label="ID" sortable width="90">
        <template slot-scope="scope">
          <el-row>
            {{ `${scope.row.idNaImobiliaria}` }}
          </el-row>

          <el-row>
            <el-col style="font-weight: bold">
              {{ `${util.getLabel(operacoesImovel, scope.row.operacao)}` }}
            </el-col>
          </el-row>
        </template>
      </el-table-column>

      <el-table-column>
        <template slot-scope="scope">
          <el-row :gutter="20" style="backgroundColor: #FFF1CC">
            <el-col style="font-weight: bold" :span="8">
              {{ `${util.getLabel(statusImovel, scope.row.status)}` }}
            </el-col>

            <el-col :span="8">
              {{ `${scope.row.tipoImovel.nome}` }}
            </el-col>

            <el-col :span="8">
              {{ `${util.formatarValor(scope.row.valor)}` }}
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col>
              {{
                `${scope.row.endereco}, ${scope.row.numeroEndereco} - ${scope.row.bairro.nome} - ${scope.row.cidade.nome}`
              }}
            </el-col>
          </el-row>
        </template>
      </el-table-column>

      <infinite-loading
        :identifier="infiniteLoadingId"
        @infinite="pesquisar"
        slot="append"
        force-use-infinite-wrapper>
        <div slot="no-more" />
        <div slot="no-results" />
      </infinite-loading>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button
        @click="selecionarImovelHandler"
        type="success"
        size="small"
        round
        class="btn-box-shadow"
      >
        <i class="el-icon-check" />
        Selecionar
      </el-button>

      <el-button
        @click="abortarSelecao"
        type="danger"
        size="small"
        round
        class="btn-box-shadow"
      >
        <i class="el-icon-close" />
        Fechar
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';

import { OPERACAO_IMOVEL, STATUS_IMOVEL } from "../../util/constantes.js";
import Util from "../../util/funcoes.js";

export default {
  props: {
    visibility: Boolean,
    status: String,
    imoveisDestaque: Array
  },
  data() {
    return {
      infiniteLoadingId: 0,
      linhaSelecionada: undefined,
      imovelPesquisa: {
        pagina: 0,
        idNaImobiliaria: undefined,
        endereco: undefined
      },
      tipoOperacao: 'TODOS',
      imoveis: [],
      labelQuantidade: ''
    }
  },
  watch: {
    'imovelPesquisa.idNaImobiliaria': function(newValue) {
      if(newValue === "") {
        this.dispararPesquisa();
      }
    },
    'imovelPesquisa.endereco': function(newValue) {
      if(newValue === "") { this.dispararPesquisa(); }
    }
  },
  computed: {
    operacoesImovel() {
      return OPERACAO_IMOVEL
    },
    statusImovel() {
      return STATUS_IMOVEL;
    },
    util() {
      return Util;
    },
    listaFiltrada(){
      return this.tipoOperacao === "TODOS" ? this.imoveis : this.imoveis.filter(imovel => {  return imovel.operacao === this.tipoOperacao})
    },
    atualizarLabelQuantidade() {
      switch (this.listaFiltrada.length) {
        case 0:
          return "Nenhum Imóvel encontrado"
        case 1:
          return "1 Imóvel encontrado";
          
        default:
          return `${this.listaFiltrada.length} Imóveis encontrados`;
      }
    },
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("logsAcessoStore", ["listarImoveis"]),
   reset() {
      this.linhaSelecionada = undefined;
      this.limparImovelPesquisa();
    },

    onOpen() {
      this.reset();
      this.dispararPesquisa();
      this.limparOperacao();
    },

    limparOperacao(){
      this.tipoOperacao = "TODOS"
    },

    dispararPesquisa() {
      this.imovelPesquisa.pagina = 0;
      this.limparImoveisListados();
      this.infiniteLoadingId += 1;
    },

    limparImoveisListados() {
      this.imoveis = [];
    },

    limparImovelPesquisa() {
      this.imovelPesquisa = {
        pagina: 0,
        idNaImobiliaria: undefined,
        endereco: undefined
      };
    },

    limparIdImovelPesquisaHandler() {
      this.dispararPesquisa();
    },

    limparEnderecoImovelPesquisaHandler() {
      this.dispararPesquisa();
    },

    atualizarImoveis(imoveis) {
      if(this.imovelPesquisa.pagina === 0) {
        this.imoveis = imoveis;
      } else {
        this.imoveis.push(...imoveis);
      }
    },

    pesquisar($state) {
      const payload = {
        ...this.imovelPesquisa,
        status: this.status ? this.status : undefined,
      };
      if(this.imovelPesquisa.pagina === 0) { this.showLoading(); }

      this.listarImoveis(payload)
        .then((resultado) => {
          
          resultado.lista = this.filtrarImoveis(resultado.lista);

          this.atualizarImoveis(resultado.lista);
          if(this.imovelPesquisa.pagina === 0) {
            this.hideLoading();
          }

          if (resultado.lista.length === 100) {
            this.imovelPesquisa.pagina += 1;
            $state.loaded();
          } else if(
            resultado.lista.length > 0 &&
            this.imovelPesquisa.pagina === 0
          ) {
            $state.loaded();
            $state.complete();
          } else {
            $state.complete();
          }
        })
        .catch(() => {
          if(this.imovelPesquisa.pagina === 0) {
            this.hideLoading();
          }
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },

    filtrarImoveis(listaResultado) {

      return listaResultado.filter(imovel => {
        return !this.imoveisDestaque.map(element => { return element.id }).includes(imovel.id) && (imovel.status === "DISPONIVEL")
      })
    },

    idInputHandler(value) {
      this.imovelPesquisa.idNaImobiliaria = value;
      this.dispararPesquisa();
    },

    enderecoInputHandler() { 
      this.dispararPesquisa();
    },

    selecaoLinhaHandler(row) {
      this.linhaSelecionada = row;
    },

    cliqueDuploLinhaHandler() {
      this.concluir();
    },

    selecionarImovelHandler() {
      if(!this.linhaSelecionada) {
        this.$message.warning("Selecione um Imóvel na tabela");
        return;
      }

      this.concluir();
    },

    abortarSelecao() {
      this.$emit('close');
    },


    concluir() {
      this.$emit('close', this.linhaSelecionada);
    }
  }
}
</script>